import { ErrorMessage, WalletErrorType } from "../shared/error";
import { useAccountStore, useChainStore } from "../shared/store";
import { getWallet } from "../wallet";
export { WalletErrorType, ErrorMessage } from "../shared/error";
export const getWalletErrorType = (message) => {
    const walletType = useAccountStore.getState().connectIssue?.walletType ??
        useAccountStore.getState().walletType();
    if (!walletType) {
        return WalletErrorType.unknown;
    }
    const { errors } = getWallet(walletType).info;
    for (const definition of errors.generic) {
        if (isErrorMessageMatch(definition.message, message)) {
            return definition.type;
        }
    }
    const { chainId } = useChainStore.getState();
    const chainErrorDefinitions = errors.chain?.[chainId];
    if (chainErrorDefinitions) {
        for (const definition of chainErrorDefinitions) {
            if (isErrorMessageMatch(definition.message, message)) {
                return definition.type;
            }
        }
    }
    switch (message) {
        case ErrorMessage.noAccount:
            return WalletErrorType.noAccount;
    }
    return WalletErrorType.unknown;
};
const isErrorMessageMatch = (errorMessage, value) => {
    if (typeof errorMessage === "string") {
        return errorMessage === value;
    }
    else {
        return errorMessage.test(value);
    }
};
//# sourceMappingURL=error.js.map